import { Box } from '@/shared/ui';

import { parseVersionHistoryText } from '@/features/factsheet/lib/versionHistory';
import type { FactsheetDetails } from '@/features/factsheet/types';

import UnregisteredBanner from '../../UnregisteredBanner';
import TextLinesDisplay from '../TextLinesDisplay';

interface QualitySpecTabProps {
  factsheet: FactsheetDetails;
  isAuthenticated: boolean;
}

const QualitySpecTab = ({ factsheet, isAuthenticated }: QualitySpecTabProps) => {
  if (!isAuthenticated) {
    return (
      <Box sx={{ pt: 5 }}>
        <UnregisteredBanner />
      </Box>
    );
  }

  const qualitySpecLines = parseVersionHistoryText(factsheet, 'qualitySpecification');

  return (
    <Box>
      <TextLinesDisplay lines={qualitySpecLines} />
    </Box>
  );
};

export default QualitySpecTab;
